import React from "react";
import {
  Box,
  Typography,
  TextField,
  Card,
  CardContent,

  Button,
  Stack,
} from "@mui/material";
import {useAuth} from "../../context/Login.context";
import HelpIcon from '@mui/icons-material/Help';
import {useNavigate} from "react-router-dom";


const UserProfile: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [firstNameState, setFirstName] = React.useState(user?.first_name);
  const [lastNameState, setLastName] = React.useState(user?.last_name);
  const [planState, ] = React.useState<string | undefined>(user?.subscription?.name);



  const handleSave = () => {
    console.log("Guardado:", {
      firstName: firstNameState,
      lastName: lastNameState,

    });
  };

  const handleCancel = () => {
    setFirstName(firstNameState);
    setLastName(lastNameState);

  };

  const handleResetTutorial = () => {
      localStorage.removeItem('tutorial_welcome_completed');
      localStorage.removeItem('tutorial_hipodromo_completed');
      localStorage.removeItem('tutorial_tops_completed');
      localStorage.removeItem('tutorial_race_detail_completed');
      localStorage.removeItem('tutorial_race_anterior_completed');
      localStorage.removeItem('tutorial_race_handicap_completed');
      localStorage.removeItem('tutorial_race_stats_completed');
      localStorage.removeItem('tutorial_race_agent_completed');
      navigate('/bienvenida');
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: "auto",
        padding: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography variant="h5" fontWeight="bold" textAlign="center">
        Perfil de Usuario
      </Typography>

      <Card>
        <CardContent>
          <TextField
            label="Nombre"
            value={firstNameState || ''}
            onChange={(e) => setFirstName(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
          />

          <TextField
            label="Apellido"
            value={lastNameState || ''}
            onChange={(e) => setLastName(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
          />

          <TextField
            label="Correo Electrónico"
            value={user?.email || ''}
            fullWidth
            margin="normal"
            variant="outlined"
            InputProps={{ readOnly: true }}
            disabled={true}
          />

          <TextField
            label="Plan de Suscripción"
            value={planState || 'Sin suscripción'}
            // onChange={(e) => setPlan(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
            disabled={true}
            />


          <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
            <Button variant="outlined" onClick={handleCancel}>
              Cancelar
            </Button>
            <Button variant="contained" color="primary" onClick={handleSave}>
              Guardar
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <Card>
          <CardContent>
              <Typography variant="h6" gutterBottom>
                  Ayuda y Configuración
              </Typography>
              <Button
                  variant="outlined"
                  startIcon={<HelpIcon />}
                  onClick={handleResetTutorial}
                  fullWidth
              >
                  Ver Tutorial de Bienvenida
              </Button>
          </CardContent>
      </Card>
    </Box>
  );
};

export default UserProfile;